"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FadeIn = function (_Component) {
  _inherits(FadeIn, _Component);

  function FadeIn() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FadeIn);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FadeIn.__proto__ || Object.getPrototypeOf(FadeIn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      maxIsVisible: 0
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FadeIn, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var count = _react2.default.Children.count(this.props.children);
      var i = 0;
      this.interval = setInterval(function () {
        i++;
        if (i > count) clearInterval(_this2.interval);

        _this2.setState({ maxIsVisible: i });
      }, this.delay);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var transitionDuration = this.transitionDuration;
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.Children.map(this.props.children, function (child, i) {
          return _react2.default.createElement(
            "div",
            {
              style: {
                transition: "opacity " + transitionDuration + "ms, top " + transitionDuration + "ms",
                position: "relative",
                top: _this3.state.maxIsVisible > i ? 0 : 20,
                opacity: _this3.state.maxIsVisible > i ? 1 : 0
              }
            },
            child
          );
        })
      );
    }
  }, {
    key: "delay",
    get: function get() {
      return this.props.delay || 50;
    }
  }, {
    key: "transitionDuration",
    get: function get() {
      return this.props.transitionDuration || 400;
    }
  }]);

  return FadeIn;
}(_react.Component);

exports.default = FadeIn;


//////////////////
// WEBPACK FOOTER
// ./~/react-fade-in/lib/FadeIn.js
// module id = 44
// module chunks = 35783957827783 70144966829960 246384609461072